import PageShell from "@/components/PageShell";
import FinalCTA from "@/components/FinalCTA";
import Contact from "@/components/Contact";

export default function ContactPage({ onLead }) {
  return (
    <PageShell backdrop="/homes/scale-1500.webp" title="Contact Akashdeep Ghai — My First Home Mortgage Ltd">
      <FinalCTA onLead={onLead} show3D={false} />
      <Contact onLead={onLead} />
    </PageShell>
  );
}
